module.exports = __webpack_public_path__ + "d902427c8a7897a0c273f30409b1d81c.png";